import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MinorCrashIcon(props: IconProps) {
    return <Icon {...props} iconKey={"minor_crash"}/>
}
